import styled from 'styled-components';
import * as GStyled from '../../../../styles/components';

const ActionButton = styled(GStyled.FlatButton)`
  display: inline-block;
`;

export { ActionButton };
